import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const BookOnline = () => (
  <Layout>
    <SEO title="Book Online" />
    <iframe
      src="http://e3cbabf6.versum.com"
      width="100%"
      height="1950"
      scrolling="yes"
      className="iframe-class"
      frameBorder="0"
    ></iframe>
  </Layout>
)

export default BookOnline
